"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Text: function() {
        return _Text.Text;
    },
    renderText_unstable: function() {
        return _Text.renderText_unstable;
    },
    textClassNames: function() {
        return _Text.textClassNames;
    },
    useTextStyles_unstable: function() {
        return _Text.useTextStyles_unstable;
    },
    useText_unstable: function() {
        return _Text.useText_unstable;
    },
    Body1: function() {
        return _Body1.Body1;
    },
    body1ClassNames: function() {
        return _Body1.body1ClassNames;
    },
    Body1Strong: function() {
        return _Body1Strong.Body1Strong;
    },
    body1StrongClassNames: function() {
        return _Body1Strong.body1StrongClassNames;
    },
    Body1Stronger: function() {
        return _Body1Stronger.Body1Stronger;
    },
    body1StrongerClassNames: function() {
        return _Body1Stronger.body1StrongerClassNames;
    },
    Body2: function() {
        return _Body2.Body2;
    },
    body2ClassNames: function() {
        return _Body2.body2ClassNames;
    },
    Caption1: function() {
        return _Caption1.Caption1;
    },
    caption1ClassNames: function() {
        return _Caption1.caption1ClassNames;
    },
    Caption1Strong: function() {
        return _Caption1Strong.Caption1Strong;
    },
    caption1StrongClassNames: function() {
        return _Caption1Strong.caption1StrongClassNames;
    },
    Caption1Stronger: function() {
        return _Caption1Stronger.Caption1Stronger;
    },
    caption1StrongerClassNames: function() {
        return _Caption1Stronger.caption1StrongerClassNames;
    },
    Caption2: function() {
        return _Caption2.Caption2;
    },
    caption2ClassNames: function() {
        return _Caption2.caption2ClassNames;
    },
    Caption2Strong: function() {
        return _Caption2Strong.Caption2Strong;
    },
    caption2StrongClassNames: function() {
        return _Caption2Strong.caption2StrongClassNames;
    },
    Display: function() {
        return _Display.Display;
    },
    displayClassNames: function() {
        return _Display.displayClassNames;
    },
    LargeTitle: function() {
        return _LargeTitle.LargeTitle;
    },
    largeTitleClassNames: function() {
        return _LargeTitle.largeTitleClassNames;
    },
    Subtitle1: function() {
        return _Subtitle1.Subtitle1;
    },
    subtitle1ClassNames: function() {
        return _Subtitle1.subtitle1ClassNames;
    },
    Subtitle2: function() {
        return _Subtitle2.Subtitle2;
    },
    subtitle2ClassNames: function() {
        return _Subtitle2.subtitle2ClassNames;
    },
    Subtitle2Stronger: function() {
        return _Subtitle2Stronger.Subtitle2Stronger;
    },
    subtitle2StrongerClassNames: function() {
        return _Subtitle2Stronger.subtitle2StrongerClassNames;
    },
    Title1: function() {
        return _Title1.Title1;
    },
    title1ClassNames: function() {
        return _Title1.title1ClassNames;
    },
    Title2: function() {
        return _Title2.Title2;
    },
    title2ClassNames: function() {
        return _Title2.title2ClassNames;
    },
    Title3: function() {
        return _Title3.Title3;
    },
    title3ClassNames: function() {
        return _Title3.title3ClassNames;
    }
});
const _Text = require("./Text");
const _Body1 = require("./Body1");
const _Body1Strong = require("./Body1Strong");
const _Body1Stronger = require("./Body1Stronger");
const _Body2 = require("./Body2");
const _Caption1 = require("./Caption1");
const _Caption1Strong = require("./Caption1Strong");
const _Caption1Stronger = require("./Caption1Stronger");
const _Caption2 = require("./Caption2");
const _Caption2Strong = require("./Caption2Strong");
const _Display = require("./Display");
const _LargeTitle = require("./LargeTitle");
const _Subtitle1 = require("./Subtitle1");
const _Subtitle2 = require("./Subtitle2");
const _Subtitle2Stronger = require("./Subtitle2Stronger");
const _Title1 = require("./Title1");
const _Title2 = require("./Title2");
const _Title3 = require("./Title3");
